import { createTheme } from "@mui/material/styles";
import colors from "./colors";

// Tema customizado para manter as cores do Material-UI v4
const theme = createTheme({
  palette: {
    primary: {
      main: colors.mui.primary, // Indigo 500 - cor primária do Material-UI v4
    },
    secondary: {
      main: colors.mui.secondary, // Pink A200 - cor secundária do Material-UI v4
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          },
        },
      },
    },
  },
});

export default theme;
